import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.jsx';
import { ErrorBoundary } from './components/system.jsx';
import { config } from './lib/config.js';
import { initPush } from './lib/push.js';

// Surface unhandled promise rejections via the same boundary the UI uses,
// rather than letting them disappear into console-only DevTools noise.
window.addEventListener('unhandledrejection', (e) => {
  // eslint-disable-next-line no-console
  console.error('[Rekraft] unhandled rejection', e.reason);
});

if (config.ENV !== 'development') {
  // eslint-disable-next-line no-console
  console.log(`[Rekraft] ${config.ENV} build`, { api: config.API_BASE_URL ? 'on' : 'mock' });
}

// Best-effort push registration; never blocks first paint.
initPush().catch(() => {});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary onReset={() => window.location.reload()}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
